<template>
   <v-row no-gutters style="color: #353535">
      <v-dialog v-model="localDialogcoppylink" persistent width="620">
         <v-card style="border-radius: 20px">
            <v-card-title>
               <v-row class="pt-5" no-gutters>
                  <v-col cols="1" md="1" xs="1" sm="1"></v-col>
                  <v-col cols="10" md="10" xs="10" sm="10">
                     <span style="font-size: 32px; color: #353535"> {{ name }} </span>
                  </v-col>
               </v-row>
               <v-row no-gutters>
                  <v-col cols="1" md="1" xs="1" sm="1"></v-col>
                  <v-col cols="10" md="10" xs="10" sm="10">
                     <!-- - สิ้นสุด : {{ enddate }}, เวลา {{ end_time }} -->
                     <span style="font-size: 16px; color: #123dea">{{ $t("message.start") }} : {{ start_time }} - {{
                        $t("message.end") }} :
                        {{ enddate }}</span>
                  </v-col>
               </v-row>
            </v-card-title>
            <v-divider class="mt-n2"></v-divider>
            <v-card-text>
               <v-row no-gutters class="mt-4">
                  <v-col cols="1" md="1" xs="1" sm="1"></v-col>
                  <v-col cols="3" md="3" xs="3" sm="3" class="mt-2">
                     <span style="font-size: 18px; font-weight: 500; color: #353535">
                        {{ $t("roomsetting.linkmeeting") }} :
                     </span>
                  </v-col>
                  <v-col cols="7" md="7" xs="7" sm="7">
                     <v-text-field solo dense v-model="link" disabled readonly
                        background-color="#EDEDED"></v-text-field>
                  </v-col>
               </v-row>
               <v-row style="gap: 24px; justify-content: center">
                  <!-- <v-col cols="4" md="4" xs="4" sm="4"></v-col> -->
                  <v-col cols="3" style="max-width: none">
                     <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                           <v-btn color="#3D85C6" block @click="copylink" outlined v-bind="attrs" v-on="on">
                              <v-icon dark> mdi-content-copy </v-icon>
                           </v-btn>
                        </template>
                        <span>{{ $t("loginpage.coppy") }}{{ $t("roomsetting.linkmeeting") }}</span>
                     </v-tooltip>
                     <input type="hidden" v-model="link" id="link" ref="link" />
                  </v-col>
                  <v-col cols="3" style="max-width: none">
                     <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                           <v-btn v-on="on" v-bind="attrs" @click="dialogU = true" outlined block color="#3D85C6">
                              <v-icon dark> mdi-qrcode-scan </v-icon></v-btn>
                        </template>
                        <span>{{ $t("loginpage.qrcode") }}</span>
                     </v-tooltip>
                     <div class="text-center">
                        <v-dialog v-model="dialogU" width="230">
                           <v-card>
                              <v-icon @click="dialogU = false" class="mt-2" right>mdi-close-thick</v-icon>
                              <v-divider></v-divider>
                              <v-card-text class="pt-12">
                                 <img :src="`data:image/png;base64,${qrcode}`" />
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                 <v-spacer></v-spacer>
                                 <v-btn color="#3D85C6" text @click="download()">
                                    <v-icon color="#3D85C6" class="pl-2">mdi-tray-arrow-down</v-icon>{{
                                       $t("button.download") }}
                                 </v-btn>
                              </v-card-actions>
                           </v-card>
                        </v-dialog>
                     </div>
                  </v-col>
               </v-row>
               <div>
                  <v-form ref="form" v-if="false">
                     <v-row no-gutters class="mt-4">
                        <v-col cols="1" md="1" xs="1" sm="1"></v-col>
                        <v-col cols="12" md="3" xs="3" sm="3" class="mt-2">
                           <span style="font-size: 18px; font-weight: 500; color: #353535">
                              เว็บไคลเอ็นต์ :
                           </span>
                        </v-col>
                        <v-col cols="12" md="7" xs="7" sm="7">
                           <v-text-field disabled outlined dense v-model="type"></v-text-field>
                        </v-col>
                     </v-row>
                  </v-form>
                  <v-form ref="form">
                     <v-row no-gutters class="mb-n2" v-if="this.password">
                        <v-col cols="1" md="1" sm="1" sx="1"></v-col>
                        <v-col cols="12" md="3" sm="3" xs="3" class="pt-2">
                           <span style="font-size: 18px; font-weight: 500; color: #353535">{{
                              $t("roomsetting.passwordrooms")
                              }}</span>
                        </v-col>
                        <v-col cols="12" md="7" sm="7" xs="7">
                           <v-text-field outlined v-model="password" dense></v-text-field>
                        </v-col>
                     </v-row>
                  </v-form>
               </div>
            </v-card-text>
            <v-card-actions>
               <v-col cols="5" md="5" xs="5" sm="5" style="margin: auto">
                  <v-btn block rounded color="error" @click="localDialogcoppylink = false">{{ $t("button.btncancel") }}
                  </v-btn>
               </v-col>
            </v-card-actions>
         </v-card>
      </v-dialog>
   </v-row>
</template>
<script>
import moment from "moment";
import { mapState, mapActions } from "vuex";

export default {
   components: {},
   create() {
      window.moment = moment;
      //  console.log('dialoglinkcoppy')
   },
   data() {
      return {
         jwt: require("jsonwebtoken"),
         name: "",
         dialogU: false,
         datenew: "",
         dateInfo: "",
         qrcode: "",
         dateintime: "",
         startdate: "",
         enddate: "",
         start_time: "",
         end_time: "",
         password: "",
         type: "",
         link: "",
      };
   },
   watch: {
      dialogcoppylink(value, oldValue) {
         if (value !== oldValue && value === true) {
            if (this.datacoppylink === null || this.datacoppylink === "") {
               this.localDialogcoppylink = false;
            } else {
               // console.log('this.coppydata', this.coppydata)
               this.coppydata = this.datacoppylink;
               this.qrcode = this.coppydata.setting.qrcode;
               this.start_time = this.coppydata.setting.startdate;
               this.end_time = this.coppydata.setting.enddate;
               this.name = this.coppydata.roomname;
               this.type = this.coppydata.setting.type;
               var textlink = process.env.VUE_APP_DOMAIN + "/join/?uuid=" + this.coppydata.uid;
               this.link = textlink + "&openExternalBrowser=1";
               if (this.coppydata.key === "123roominet!") {
                  this.password = "";
               } else {
                  let splitKey = this.coppydata.key.split(":inet!");
                  this.password = splitKey[0];
                  // this.password = this.coppydata.key
               }
               this.startdate = this.coppydata.setting.startdate;
               this.enddate = this.coppydata.setting.enddate;
               // var d = this.coppydata.date.substr(0, 2)
               // var m = this.coppydata.date.substr(3, 2)
               // var y = this.coppydata.date.substr(6, 4)
               // var newdate = y + '-' + m + '-' + d
               // var options = {
               //     weekday: 'long',
               //     year: 'numeric',
               //     month: 'long',
               //     day: 'numeric'
               //     }
               // var today = new Date(
               //     parseInt(newdate.slice(6)),
               //     parseInt(newdate.slice(3, 5)) - 1,
               //     parseInt(newdate.slice(0, 2))
               //     )
               //     this.dateInfo = today.toLocaleDateString('en-US', options)
               //     var l = this.dateInfo.substr(0, 9)
               //     var e = this.dateInfo.substr(9,7)
               //     var newtoday = l + d + e + y
               //     this.dateintime = newtoday
            }
         }
      },
   },
   computed: {
      ...mapState("dialog", ["dialogcoppylink", "datacoppylink"]),
      localDialogcoppylink: {
         get() {
            return this.dialogcoppylink;
         },
         set(value) {
            this.setDialogcoppylink(value);
         },
      },
   },
   methods: {
      ...mapActions("dialog", ["setDialogcoppylink"]),
      async copylink() {
         try {
            const respone = await this.axios({
               method: 'get',
               url: process.env.VUE_APP_API + '/api/lv1/room/getroominfo/' + this.datacoppylink.uid,
               headers: { Authorization: `Bearer ${localStorage.getItem("user-token")}` },
            })
            const data = JSON.parse(this.decodeJS(respone.data.data));
            const startDate = this.datacoppylink.setting.startdate;
            const data_info = `${data.name} ได้เชิญคุณเข้าร่วมการประชุมล่วงหน้า\n \nหัวข้อการประชุม: ${data.topic} \nประเภทการประชุม: ${data.meeting_type} \nเวลาเริ่มการประชุม: ${startDate}\n \nลิงก์เข้าร่วมการประชุม: \n${data.url}&openExternalBrowser=1 \nไอดีห้อง: ${data.room_id} ${data.passcode === '' ? '' : '\nรหัสเข้าห้องประชุม:' + data.passcode}`
            var link = document.getElementById("link");
            link.type = "text";
            link.select();
            link.setSelectionRange(0, 99999); /* For mobile devices */
            document.execCommand("copy");
            link.type = "hidden";
            navigator.clipboard.writeText(data_info);
            this.$swal(this.$t("loginpage.coppylink"), "", "success");
         } catch (error) {
            console.log(error);
            var link = document.getElementById("link");
            link.type = "text";
            link.select();
            link.setSelectionRange(0, 99999); /* For mobile devices */
            document.execCommand("copy");
            link.type = "hidden";
            this.$swal(this.$t("loginpage.coppylink"), "", "success");
         }
      },
      download() {
         const linkSource = "data:png/jpg;base64," + this.qrcode;
         const downloadLink = document.createElement("a");
         document.body.appendChild(downloadLink);
         downloadLink.href = linkSource;
         downloadLink.download = "QR_CODE" + this.name + ".jpg";
         downloadLink.click();
      },
      decodeJS(data) {
         try {
            var bytes = this.CryptoJS.AES.decrypt(data, process.env.VUE_APP_SECRET_KEY);
            var decryptedData = JSON.parse(bytes.toString(this.CryptoJS.enc.Utf8));
            return decryptedData;
         } catch (error) {
            console.log(">>>>>>>>", error);
            return error;
         }
      },
      toThaiDateString(date) {
         let hour = date.getHours().toString().padStart(2, "0");
         let minutes = date.getMinutes().toString().padStart(2, "0");
         let second = date.getSeconds().toString().padStart(2, "0");

         return date.toLocaleDateString('th-TH', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
         }) +
            ` ${hour}:${minutes}:${second} น.`;
      }
   },
};
</script>
<style scoped></style>
